/**
 * Common types and constants used across the application
 */

// South African High School Grade Levels
export const GRADE_LEVELS = [
  { value: 8, label: 'Grade 8' },
  { value: 9, label: 'Grade 9' },
  { value: 10, label: 'Grade 10' },
  { value: 11, label: 'Grade 11' },
  { value: 12, label: 'Grade 12' },
] as const;

// PAT (Practical Assessment Task) Types
export const PAT_TYPES = [
  { value: 'specifications', label: 'Phase 1: Specifications' },
  { value: 'design', label: 'Phase 2: Design' },
  { value: 'coding', label: 'Phase 3: Coding & Development' },
  { value: 'technical', label: 'Phase 4: Technical Documentation' },
  { value: 'testing', label: 'Phase 5: Testing & Debugging' },
] as const;

// Assignment Types
export const ASSIGNMENT_TYPES = [
  { value: 'general', label: 'General Assignment' },
  { value: 'pat', label: 'PAT Project' },
  { value: 'exam', label: 'Exam' },
  { value: 'test', label: 'Test' },
  { value: 'quiz', label: 'Quiz' },
  { value: 'project', label: 'Project' },
  { value: 'practical', label: 'Practical Task' },
] as const;

export type GradeLevel = typeof GRADE_LEVELS[number]['value'];
export type PATType = typeof PAT_TYPES[number]['value'];
export type AssignmentType = typeof ASSIGNMENT_TYPES[number]['value'];
